import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Newsletter } from '@models/newsletter';

export interface NewsletterFormValues {
  approvalDueOn: Date;
  name: string;
  printQuantity: number;
  submissionDueOn: Date;
}

@Component({
  selector: 'app-newsletter-form',
  templateUrl: './newsletter-form.component.html',
  styleUrls: ['./newsletter-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterFormComponent implements OnInit {
  @Input() public form: UntypedFormGroup;

  static formModel(formValues = null) {
    return new UntypedFormGroup({
      approvalDueOn: new UntypedFormControl(
        formValues ? formValues.approvalDueOn : null,
        Validators.required
      ),
      name: new UntypedFormControl(
        formValues ? formValues.name : null,
        Validators.required
      ),
      printQuantity: new UntypedFormControl(
        formValues ? formValues.name : null,
        Validators.required
      ),
      submissionDueOn: new UntypedFormControl(
        formValues ? formValues.approvalDueOn : null,
        Validators.required
      ),
    });
  }

  static serialize(
    formValues: NewsletterFormValues,
    newsletter: Partial<Newsletter> = {}
  ): Partial<Newsletter> {
    const serializedForm = {
      approvalDueOn: formValues.approvalDueOn,
      name: formValues.name,
      printQuantity: formValues.printQuantity,
      submissionDueOn: formValues.submissionDueOn,
      articleCount: 4, // Always set to 4 articles
    };

    return Object.assign(newsletter, serializedForm);
  }

  static deserialize(newsletter: Newsletter): NewsletterFormValues {
    return {
      approvalDueOn: newsletter.approvalDueOn,
      name: newsletter.name,
      printQuantity: newsletter.printQuantity,
      submissionDueOn: newsletter.submissionDueOn,
    };
  }

  constructor() {}

  ngOnInit() {}
}
